"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    HorizontalChart: {
      display: 'flex',
      minWidth: 170,
      minHeight: 170,
      '& .Chart': {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1
      },
      '& .Labels': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        paddingRight: 10,
        fontSize: 11,
        fontWeight: 'bold',
        fontFamily: 'Roboto'
      }
    },
    HorizontalBarWrapper: {
      display: 'flex',
      flexGrow: 1,
      borderBottom: "1px solid ".concat(theme['$bar-chart-horizontal-border-color']),
      '& .HorizontalBar': {
        display: 'flex',
        alignContent: 'flex-end',
        alignItems: 'flex-end',
        flexDirection: 'row-reverse',
        width: '100%',
        position: 'relative',
        transition: 'all 1s',
        '& .value': {
          position: 'absolute',
          fontFamily: 'Roboto',
          fontSize: 12,
          width: 200,
          right: 10,
          bottom: 10,
          textAlign: 'right',
          '&.right': {
            textAlign: 'left',
            right: '-210px'
          }
        }
      },
      '&:nth-child(4n+1) .HorizontalBar': {
        backgroundColor: theme['$bar-chart-primary-alt'],
        borderRight: "2px solid ".concat(theme['$bar-chart-primary'])
      },
      '&:nth-child(4n+2) .HorizontalBar': {
        backgroundColor: theme['$bar-chart-secondary-alt'],
        borderRight: "2px solid ".concat(theme['$bar-chart-secondary'])
      },
      '&:nth-child(4n+3) .HorizontalBar': {
        backgroundColor: theme['$bar-chart-tertiary-alt'],
        borderRight: "2px solid ".concat(theme['$bar-chart-tertiary'])
      },
      '&:nth-child(4n+4) .HorizontalBar': {
        backgroundColor: theme['$bar-chart-quaternary-alt'],
        borderRight: "2px solid ".concat(theme['$bar-chart-quaternary'])
      },
      '&:last-child': {
        borderBottom: "1px solid ".concat(theme['$bar-chart-border-color'])
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map